// A uniform integer in [0, bound): plain modulo would favour the low end, so the skewing values are redrawn.
export function randomBelow(bound: number): number {
  const limit = Math.floor(0x100000000 / bound) * bound;
  let value: number;
  do {
    value = randomWord();
  } while (value >= limit);
  return value % bound;
}

// Fisher-Yates, in place.
export function shuffle<T>(items: T[]): void {
  for (let i = items.length - 1; i > 0; i--) {
    const j = randomBelow(i + 1);
    [items[i], items[j]] = [items[j], items[i]];
  }
}

// Four bytes per CSPRNG call is ~4 ms a frame while a slider is dragged; one buffer read down costs a twentieth.
const ENTROPY_POOL = new Uint32Array(512);
let poolNext = ENTROPY_POOL.length;

function randomWord(): number {
  if (poolNext >= ENTROPY_POOL.length) {
    crypto.getRandomValues(ENTROPY_POOL);
    poolNext = 0;
  }
  return ENTROPY_POOL[poolNext++];
}
